import { ButtonComponent } from '@syncfusion/ej2-react-buttons'
import { FC, useState } from 'react'

type ToggleAllAccordionProps = {
  expandAll: () => void
  collapseAll: () => void
}

export const ToggleAllAccordionBtn: FC<ToggleAllAccordionProps> = ({ expandAll, collapseAll }) => {
  const [areAllExpanded, setAreAllExpanded] = useState(true)

  function handleBtnClick() {
    if (areAllExpanded) {
      collapseAll()
      setAreAllExpanded(false)
    } else {
      expandAll()
      setAreAllExpanded(true)
    }
  }

  const buttonText = areAllExpanded ? 'Alle Kapitel einklappen' : 'Alle Kapitel ausklappen'
  const buttonIcon = areAllExpanded ? 'e-icons e-collapse-2' : 'e-icons e-expand'

  return <ButtonComponent type={'button'} cssClass="e-flat e-link" style={{ background: 'none', padding: 0 }} iconCss={buttonIcon} content={buttonText} isToggle={true} onClick={handleBtnClick} />
}
